import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import HomeOne from './HomeOne'
import About from './About'
import DailyMeals from './DailyMeals'
import CateringPage from './Catering'

// ✔ Updated names
import CorporatePage from './Corporate'
import FoodDeliveryInTrainPage from './FoodDeliveryInTrain'
import MealSubscriptionPage from './MealSubscription'
import PreOrderMealsPage from './PreOrderMeals'
import GiftingPage from './Gifting'
import BlogList from "../Blog/Blogs";
import BlogDetails from "./BlogDetails";
import Contact from './Contact'
import LoadTop from '../Components/LoadTop'

const AdminApp = lazy(() => import('../Admin/AdminApp'))

function RouterPage() {
  const pathname = window.location.pathname;
  const basename = pathname.includes('/tt-react/build') ? '/tt-react/build' : undefined;

  return (
    <Router basename={basename}>
      <LoadTop />
      <Routes>
        <Route path="/" element={<HomeOne />} />
        <Route path="/about" element={<About />} />
        <Route path="/daily-meals" element={<DailyMeals />} />
        <Route path="/catering" element={<CateringPage />} />

        {/* ✔ FIXED — use the renamed components */}
        <Route path="/corporate" element={<CorporatePage />} />
        <Route path="/food-delivery-in-train" element={<FoodDeliveryInTrainPage />} />
        <Route path="/meal-subscription" element={<MealSubscriptionPage />} />
        <Route path="/pre-order-meals" element={<PreOrderMealsPage />} />
        <Route path="/gifting" element={<GiftingPage />} />

        <Route path="/blogs" element={<BlogList />} />

        <Route path="/:id" element={<BlogDetails />} />

        <Route path="/contact" element={<Contact />} />

        <Route
          path="/admin/*"
          element={(
            <Suspense fallback={<div className="admin-splash"><div className="admin-spinner" /></div>}>
              <AdminApp />
            </Suspense>
          )}
        />
      </Routes>
    </Router>
  )
}

export default RouterPage
